module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogSubCategories":{"heading":"Kategorie"}},"de":{"CatalogSubCategories":{"heading":"Kategorien"}},"sk":{"CatalogSubCategories":{"heading":"Kategórie"}}}')
  delete Component.options._Ctor
}
